euCountries = require 'app/scripts/data/eu-countries'

isQuebec = (country, zipCode) ->
  country == 'CA' && /^[GHJ]/i.test(zipCode)

module.exports =
  hasTaxNumbers: (country, zipCode) ->
    euCountries.indexOf(country) != -1 ||
    isQuebec(country, zipCode) ||
    ['AU', 'KR', 'NO', 'NZ'].indexOf(country) != -1

  taxType: (country, zipCode) ->
    if country == 'AU'
      'ABN'
    else if country == 'NZ'
      'GST'
    else if isQuebec(country, zipCode)
      'QST'
    else
      'VAT'

  testTaxId: (taxId, { country, zipCode }) ->
    if taxId.length
      taxDigitsLength = taxId.replace(/\D/g, '').length
      maxLength = if isQuebec(country, zipCode) then 14 else 12
      # http://ec.europa.eu/taxation_customs/vies/faq.html Q11
      taxDigitsLength >= 2 && taxDigitsLength <= maxLength
    else
      true
